import { ResolveFn } from '@angular/router';
import { IClientUserAccount } from '../interfaces/database-models/IClientUserAccount';
import { inject } from '@angular/core';
import { ClientAccountService } from '../client/api-services/client-account.service';
import { ClientAuthService } from '../client/client-auth.service';

export const getCurrentClientAccountResolver: ResolveFn<IClientUserAccount | null> = async () => {
  return await new Promise<IClientUserAccount | null>(resolve => {
    const clientAuthService = inject(ClientAuthService);
    const clientAccountsService = inject(ClientAccountService);

    const clientLoginToken = clientAuthService.GetAuthToken();
    if (clientLoginToken !== null){
      clientAccountsService.GetCurrentAccount().subscribe({
        next: apiResponse => {
          return resolve(apiResponse.Data!);
        },
        error: () => {
          return resolve(null);
        }
      });
    } else {
      return resolve(null);
    }
  });
};
